// supported locales
export default ['et', 'en']